import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { setFpact } from '../../actions/userActions';

@connect((store) => { return { }; })
class Fpact extends React.Component {
    goToHasFpact() {
        this.props.dispatch(setFpact(true));
        this.props.history.push('/hasfpact');
    }

    goToNoFpact() {
        this.props.dispatch(setFpact(false));
        this.props.history.push('/nofpact');
    }

    render() {
        return (
            <div>
                <div className="row justify-content-md-center">
                    <div className="col-md-6 text-center">
                        <h1 className="ec__font__title">Do you have a green FPACT card?</h1>
                        <p className="ec__font__body">It looks like this:</p>
                        <img className="fpact-image" src="./images/FPACTcard.png"/>
                    </div>
                </div>

                <div className="choices choices--small row">
                    <div className="col text-center">
                        <button className="ec__button" onClick={this.goToHasFpact.bind(this)}>Yes</button>
                    </div>
                    <div className="col text-center">
                        <button className="ec__button" onClick={this.goToNoFpact.bind(this)}>No</button>
                    </div>
                </div>

                <div className="row">
                    <div className="col text-center">
                        <a href="http://www.familypact.org/Get%20Covered/client-eligibility-enrollment/eligibility-criteria"
                            target="_blank" rel="noopener" class="ec__text-link">
                            What is FPACT?
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default Fpact;


// WEBPACK FOOTER //
// ./src/components/screens/Fpact.js